import React from 'react';
import { UI_CONSTANTS } from '../../constants/uiConstants';
import { combineClasses } from '../../utils/formatters';

const SearchBar = ({ searchTerm, onSearchChange, onSearch, placeholder }) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSearch) onSearch(searchTerm);
  };

  return (
    <form onSubmit={handleSubmit} className="w-full">
      <div className="relative">
        <input
          type="text"
          placeholder={placeholder || "What spiritual service are you looking for?"}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className={combineClasses(
            "w-full pl-6 pr-32 py-4 text-lg border-2 border-orange-200",
            "focus:border-orange-400 focus:outline-none focus:ring-2 focus:ring-orange-100",
            "bg-white/90 backdrop-blur-sm placeholder-gray-500",
            UI_CONSTANTS.RADIUS.LG,
            UI_CONSTANTS.SHADOWS.LG,
            UI_CONSTANTS.TRANSITIONS.DEFAULT
          )}
        />
        <button 
          type="submit"
          className={combineClasses(
            "absolute right-2 top-1/2 transform -translate-y-1/2",
            "bg-gradient-to-r from-orange-500 to-orange-600 text-white",
            "px-6 py-2.5 font-semibold",
            "hover:from-orange-600 hover:to-orange-700",
            "focus:outline-none focus:ring-2 focus:ring-orange-300",
            "shadow-md hover:shadow-lg",
            UI_CONSTANTS.RADIUS.MD,
            UI_CONSTANTS.TRANSITIONS.DEFAULT
          )}
        >
          🔍 Search
        </button>
      </div>
    </form>
  );
};

export default SearchBar;
